import type { ExperimentId, ExperimentVariant } from "@/utils/env/experiments";

import { webEvent } from "./event";

/**
 * Track that a user is assigned to a variant in an experiment (a/b test, which are run by posthog)
 */
export const variantAssigned = <T extends ExperimentId>(
  experimentName: T,
  variant: ExperimentVariant<T>,
) => webEvent("experiment", "variant_assigned", { experimentName, variant });
